import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from "@mui/material/Divider";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { cardStyle } from "../../../Dashboard/customStyles";
import { generateAssumptions, updateAssumptions } from "../../../../store/modules/waterfall/actions";
import { primary } from "../../../../assets/colorPallet";
import FeeItem from "./FeeItem";
import Item from "../InputItem";

function OtherAssumptions({
  dealType,
  assumptions,
  dispatchGenerateAssumptions,
  dispatchUpdateAssumptions,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateAssumptions(dealType);
  }, []);

  const handleChange = (name, value, type = "Common", index = 0) => {
    dispatchUpdateAssumptions(name, value, type, index);
  };

  return (
    <div>
      {assumptions && (
        <>
          <div className="flex flex-wrap justify-center">
            <Card sx={cardStyle.wideCard}>
              <CardHeader
                sx={{ background: primary }}
                titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                title="Ownership Structure"
              />
              <CardContent sx={{ padding: "20px 30px" }}>
                <div className="flex items-center text-center my-5 px-10">
                  <div className="w-1/4" />
                  <div className="w-1/4 text-lg font-semibold">Common Management</div>
                  <div className="w-1/4 text-lg font-semibold">General Partner (Sponsor)</div>
                  <div className="w-1/4 text-lg font-semibold">Limited Partner</div>
                </div>
                <div className="flex items-center mb-5 px-10">
                  <div className="w-1/4 text-lg">Cash Contribution</div>
                  <div className="w-1/4 text-center">
                    <BVAInput size="small" width="170px" value="" disabled />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.GPContributionAmount}
                      onChange={(value) => handleChange("GPContributionAmount", value)}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.LPContributionAmount}
                    />
                  </div>
                </div>
                <div className="flex items-center mb-5 px-10">
                  <div className="w-1/4 text-lg">Percentage of Cash Contributed</div>
                  <div className="w-1/4 text-center">
                    <BVAInput size="small" width="170px" value="" disabled />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.GPContributionPercent}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.LPContributionPercent}
                    />
                  </div>
                </div>
                <div className="flex items-center mb-5 px-10">
                  <div className="w-1/4 text-lg">Fully Diluted Ownership Percentage</div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.CMOwnershipPercent}
                      onChange={(value) => handleChange("CMOwnershipPercent", value)}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.GPOwnershipPercent}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.LPOwnershipPercent}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card sx={cardStyle.wideCard}>
              <CardHeader
                sx={{ background: primary }}
                titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                title="Fees"
              />
              <CardContent sx={{ padding: "20px 30px" }}>
                <div className="flex items-center text-center my-5 px-10">
                  <div className="w-1/2" />
                  <div className="w-1/4 text-lg font-semibold">General Partner (Sponsor)</div>
                  <div className="w-1/4 text-lg font-semibold">Limited Partner</div>
                </div>
                <div className="flex items-center mb-5 px-10">
                  <div className="w-1/2 text-lg">Closing Fee (Percentage of Total Closing Fees)</div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.GPContributionPercent}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="%"
                      value={assumptions.LPContributionPercent}
                    />
                  </div>
                </div>
                <div className="flex items-center mb-5 px-10">
                  <div className="w-1/2 text-lg font-semibold">Closing Fee Amount</div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.GPClosingFeeAmount}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.LPClosingFeeAmount}
                    />
                  </div>
                </div>
                <div className="h-7" />
                <FeeItem name="Management" handleChange={handleChange} />
                <FeeItem name="Administrative" handleChange={handleChange} />
                <FeeItem name="Director" handleChange={handleChange} />
                <FeeItem name="Placement" handleChange={handleChange} />
                <Divider />
                <div className="flex items-center my-5 px-10">
                  <div className="w-1/2 text-lg font-semibold">Total Annual Fees</div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.GPTotalAnnualFees}
                    />
                  </div>
                  <div className="w-1/4 text-center">
                    <BVAInput
                      size="small"
                      width="170px"
                      disabled
                      endAdornment
                      endAdornmentLabel="$"
                      value={assumptions.LPTotalAnnualFees}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>

            {assumptions.proceeds === "PPS" && assumptions.schedule.map((schedule, index) => (
              <>
                <Card sx={cardStyle.dealCard}>
                  <CardHeader
                    sx={{ background: primary }}
                    titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                    title={"Tranche " + (index + 1)}
                  />
                  <CardContent sx={{ padding: "20px 30px" }}>
                    <div className="flex text-center justify-between items-center my-3 px-5">
                      <div className="items-center text-lg">Preferred Return Provision</div>
                      <FormControl variant="standard" sx={{ m: 1, width: 155 }}>
                        <Select
                          value={schedule.tranche}
                          onChange={(e) => handleChange("tranche", e.target.value, "Schedule", index)}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    {schedule.tranche && (
                      <>
                        <Item
                          name="preferred Hurdle"
                          data={schedule.hurdle}
                          endLabel="%"
                          handleChange={(value) => handleChange("hurdle", value, "Schedule", index)}
                        />
                        {assumptions.basis === "MULTI" && (
                          <Item
                            name="preferred Hurdle for Equity Multiple"
                            data={schedule.multiHurdle}
                            endLabel="x"
                            handleChange={(value) => handleChange("multiHurdle", value, "Schedule", index)}
                          />
                        )}
                        <Item
                          name="GP Promote"
                          data={schedule.promote}
                          disabled={index === 0 ? true : false}
                          endLabel="%"
                          handleChange={(value) => handleChange("promote", value, "Schedule", index)}
                        />
                        <Item
                          name="GP Cash Split"
                          data={schedule.trancheGPSplit}
                          disabled={true}
                          endLabel="%"
                        />
                        <Item
                          name="LP Cash Split"
                          data={schedule.trancheLPSplit}
                          disabled={true}
                          endLabel="%"
                        />
                      </>
                    )}
                  </CardContent>
                </Card>
                <Card sx={cardStyle.dealCard}>
                  <CardHeader
                    sx={{ background: primary }}
                    titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                    title={"Catch-Up " + (index + 1)}
                  />
                  <CardContent sx={{ padding: "20px 30px" }}>
                    <div className="flex text-center justify-between items-center my-3 px-5">
                      <div className="items-center text-lg">Catch-Up Provision</div>
                      <FormControl variant="standard" sx={{ m: 1, width: 155 }}>
                        <Select
                          value={schedule.catchUp}
                          onChange={(e) => handleChange("catchUp", e.target.value, "Schedule", index)}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    {schedule.catchUp && (
                      <>
                        <Item
                          name="GP Catch-Up Percentage"
                          data={schedule.catchUpPercent}
                          endLabel="%"
                          handleChange={(value) => handleChange("catchUpPercent", value, "Schedule", index)}
                        />
                        <Item
                          name="GP Cash Split"
                          data={schedule.catchUpGPSplit}
                          endLabel="%"
                          handleChange={(value) => handleChange("catchUpGPSplit", value, "Schedule", index)}
                        />
                        <Item
                          name="LP Cash Split"
                          data={schedule.catchUpLPSplit}
                          disabled={true}
                          endLabel="%"
                        />
                      </>
                    )}
                  </CardContent>
                </Card>
              </>
            ))}

            {assumptions.proceeds === "PPS" && (
              <Card sx={cardStyle.dealCard}>
                <CardHeader
                  sx={{ background: primary }}
                  titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                  title="Clawback"
                />
                <CardContent sx={{ padding: "20px 30px", height: "300px" }}>
                  <div className="flex text-center justify-between items-center my-3 px-5">
                    <div className="items-center text-lg">Are LPs Eligible for a Clawback?</div>
                    <FormControl variant="standard" sx={{ m: 1, width: 155 }}>
                      <Select
                        value={assumptions.clawback}
                        onChange={(e) => handleChange("clawback", e.target.value)}
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
  async dispatchUpdateAssumptions(name, value, type, index) {
    await dispatch(updateAssumptions(name, value, type, index));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OtherAssumptions);
